import React from "react";
import { View, StyleSheet, Pressable } from "react-native";
import { ThemedText } from "@/components/ThemedText";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { useTheme } from "@/hooks/useTheme";
import type { CopyOption, CopyOptionsChipsProps, CopyOptionConfig } from "./types";

const COPY_OPTIONS: CopyOptionConfig[] = [
  { value: "billing", label: "Billing", icon: "cash-register" },
  { value: "payroll", label: "Payroll", icon: "account-cash" },
  { value: "both", label: "Both", icon: "content-duplicate" },
  { value: "none", label: "None", icon: "close-circle-outline" },
];

export function CopyOptionsChips({ selectedOption, onOptionChange }: CopyOptionsChipsProps) {
  const { colors } = useTheme();

  return (
    <View style={styles.container}>
      {COPY_OPTIONS.map((option) => {
        const isSelected = selectedOption === option.value;
        return (
          <Pressable
            key={option.value}
            style={[
              styles.chip,
              {
                backgroundColor: isSelected ? colors.primary : colors.backgroundSecondary,
                borderColor: isSelected ? colors.primary : colors.border,
              },
            ]}
            onPress={() => onOptionChange(option.value)}
          >
            <MaterialCommunityIcons
              name={option.icon as any}
              size={14}
              color={isSelected ? "white" : colors.textSecondary}
            />
            <ThemedText style={[styles.label, { color: isSelected ? "white" : colors.text }]}>
              {option.label}
            </ThemedText>
          </Pressable>
        );
      })}
    </View>
  );
}

export { COPY_OPTIONS };

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 6,
  },
  chip: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 6,
    borderWidth: 1,
    gap: 4,
  },
  label: {
    fontSize: 12,
    fontWeight: "500",
  },
});
